function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    e = function e(t) {
  return t && t.Math == Math && t;
},
    r = e("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis) || e("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) || e("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) || e("object" == _typeof(t) && t) || function () {
  return this;
}() || Function("return this")(),
    n = {},
    o = function o(t) {
  try {
    return !!t();
  } catch (t) {
    return !0;
  }
},
    i = !o(function () {
  return 7 != Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1];
}),
    a = {},
    s = {}.propertyIsEnumerable,
    u = Object.getOwnPropertyDescriptor,
    c = u && !s.call({
  1: 2
}, 1);

a.f = c ? function (t) {
  var e = u(this, t);
  return !!e && e.enumerable;
} : s;

var f = function f(t, e) {
  return {
    enumerable: !(1 & t),
    configurable: !(2 & t),
    writable: !(4 & t),
    value: e
  };
},
    l = {}.toString,
    h = function h(t) {
  return l.call(t).slice(8, -1);
},
    p = "".split,
    d = function d(t) {
  if (null == t) throw TypeError("Can't call method on " + t);
  return t;
},
    v = o(function () {
  return !Object("z").propertyIsEnumerable(0);
}) ? function (t) {
  return "String" == h(t) ? p.call(t, "") : Object(t);
} : Object,
    m = d,
    y = function y(t) {
  return v(m(t));
},
    g = function g(t) {
  return "object" == _typeof(t) ? null !== t : "function" == typeof t;
},
    w = g,
    b = function b(t, e) {
  if (!w(t)) return t;
  var r, n;
  if (e && "function" == typeof (r = t.toString) && !w(n = r.call(t))) return n;
  if ("function" == typeof (r = t.valueOf) && !w(n = r.call(t))) return n;
  if (!e && "function" == typeof (r = t.toString) && !w(n = r.call(t))) return n;
  throw TypeError("Can't convert object to primitive value");
},
    O = d,
    S = function S(t) {
  return Object(O(t));
},
    x = {}.hasOwnProperty,
    E = Object.hasOwn || function (t, e) {
  return x.call(S(t), e);
},
    _ = g,
    j = r.document,
    T = _(j) && _(j.createElement),
    k = function k(t) {
  return T ? j.createElement(t) : {};
},
    P = !i && !o(function () {
  return 7 != Object.defineProperty(k("div"), "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    L = i,
    D = a,
    I = f,
    R = y,
    M = b,
    F = E,
    C = P,
    V = Object.getOwnPropertyDescriptor;

n.f = L ? V : function (t, e) {
  if (t = R(t), e = M(e, !0), C) try {
    return V(t, e);
  } catch (t) {}
  if (F(t, e)) return I(!D.f.call(t, e), t[e]);
};

var A = {},
    G = g,
    N = function N(t) {
  if (!G(t)) throw TypeError(String(t) + " is not an object");
  return t;
},
    q = i,
    U = P,
    W = N,
    B = b,
    z = Object.defineProperty;

A.f = q ? z : function (t, e, r) {
  if (W(t), e = B(e, !0), W(r), U) try {
    return z(t, e, r);
  } catch (t) {}
  if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
  return "value" in r && (t[e] = r.value), t;
};

var K = A,
    Y = f,
    X = i ? function (t, e, r) {
  return K.f(t, e, Y(1, r));
} : function (t, e, r) {
  return t[e] = r, t;
},
    H = {
  exports: {}
},
    J = r,
    $ = X,
    Q = function Q(t, e) {
  try {
    $(J, t, e);
  } catch (r) {
    J[t] = e;
  }

  return e;
},
    Z = Q,
    tt = r["__core-js_shared__"] || Z("__core-js_shared__", {}),
    et = tt,
    rt = Function.toString;

"function" != typeof et.inspectSource && (et.inspectSource = function (t) {
  return rt.call(t);
});
var nt = et.inspectSource,
    ot = nt,
    it = r.WeakMap,
    at = "function" == typeof it && /native code/.test(ot(it)),
    st = {
  exports: {}
},
    ut = tt;
(st.exports = function (t, e) {
  return ut[t] || (ut[t] = void 0 !== e ? e : {});
})("versions", []).push({
  version: "3.15.2",
  mode: "global",
  copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
});

var ct,
    ft,
    lt,
    ht = 0,
    pt = Math.random(),
    dt = st.exports,
    vt = function vt(t) {
  return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++ht + pt).toString(36);
},
    mt = dt("keys"),
    yt = {},
    gt = at,
    wt = g,
    bt = X,
    Ot = E,
    St = tt,
    xt = function xt(t) {
  return mt[t] || (mt[t] = vt(t));
},
    Et = yt,
    _t = r.WeakMap;

if (gt || St.state) {
  var jt = St.state || (St.state = new _t()),
      Tt = jt.get,
      kt = jt.has,
      Pt = jt.set;
  ct = function ct(t, e) {
    if (kt.call(jt, t)) throw new TypeError("Object already initialized");
    return e.facade = t, Pt.call(jt, t, e), e;
  }, ft = function ft(t) {
    return Tt.call(jt, t) || {};
  }, lt = function lt(t) {
    return kt.call(jt, t);
  };
} else {
  var Lt = xt("state");
  Et[Lt] = !0, ct = function ct(t, e) {
    if (Ot(t, Lt)) throw new TypeError("Object already initialized");
    return e.facade = t, bt(t, Lt, e), e;
  }, ft = function ft(t) {
    return Ot(t, Lt) ? t[Lt] : {};
  }, lt = function lt(t) {
    return Ot(t, Lt);
  };
}

var Dt = {
  set: ct,
  get: ft,
  has: lt,
  enforce: function enforce(t) {
    return lt(t) ? ft(t) : ct(t, {});
  },
  getterFor: function getterFor(t) {
    return function (e) {
      var r;
      if (!wt(e) || (r = ft(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
      return r;
    };
  }
},
    It = r,
    Rt = X,
    Mt = E,
    Ft = Q,
    Ct = nt,
    Vt = Dt.get,
    At = Dt.enforce,
    Gt = String(String).split("String");
(H.exports = function (t, e, r, n) {
  var o,
      i = !!n && !!n.unsafe,
      a = !!n && !!n.enumerable,
      s = !!n && !!n.noTargetGet;
  "function" == typeof r && ("string" != typeof e || Mt(r, "name") || Rt(r, "name", e), (o = At(r)).source || (o.source = Gt.join("string" == typeof e ? e : ""))), t !== It ? (i ? !s && t[e] && (a = !0) : delete t[e], a ? t[e] = r : Rt(t, e, r)) : a ? t[e] = r : Ft(e, r);
})(Function.prototype, "toString", function () {
  return "function" == typeof this && Vt(this).source || Ct(this);
});

var Nt = r,
    qt = r,
    Ut = function Ut(t) {
  return "function" == typeof t ? t : void 0;
},
    Wt = {},
    Bt = Math.ceil,
    zt = Math.floor,
    Kt = function Kt(t) {
  return isNaN(t = +t) ? 0 : (t > 0 ? zt : Bt)(t);
},
    Yt = Kt,
    Xt = Math.min,
    Ht = Kt,
    Jt = Math.max,
    $t = Math.min,
    Qt = y,
    Zt = function Zt(t) {
  return t > 0 ? Xt(Yt(t), 9007199254740991) : 0;
},
    te = function te(t, e) {
  var r = Ht(t);
  return r < 0 ? Jt(r + e, 0) : $t(r, e);
},
    ee = function ee(t) {
  return function (e, r, n) {
    var o,
        i = Qt(e),
        a = Zt(i.length),
        s = te(n, a);

    if (t && r != r) {
      for (; a > s;) {
        if ((o = i[s++]) != o) return !0;
      }
    } else for (; a > s; s++) {
      if ((t || s in i) && i[s] === r) return t || s || 0;
    }

    return !t && -1;
  };
},
    re = {
  includes: ee(!0),
  indexOf: ee(!1)
},
    ne = E,
    oe = y,
    ie = re.indexOf,
    ae = yt,
    se = function se(t, e) {
  var r,
      n = oe(t),
      o = 0,
      i = [];

  for (r in n) {
    !ne(ae, r) && ne(n, r) && i.push(r);
  }

  for (; e.length > o;) {
    ne(n, r = e[o++]) && (~ie(i, r) || i.push(r));
  }

  return i;
},
    ue = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    ce = se,
    fe = ue.concat("length", "prototype");

Wt.f = Object.getOwnPropertyNames || function (t) {
  return ce(t, fe);
};

var le = {};
le.f = Object.getOwnPropertySymbols;

var he = Wt,
    pe = le,
    de = N,
    ve = function (t, e) {
  return arguments.length < 2 ? Ut(Nt[t]) || Ut(qt[t]) : Nt[t] && Nt[t][e] || qt[t] && qt[t][e];
}("Reflect", "ownKeys") || function (t) {
  var e = he.f(de(t)),
      r = pe.f;
  return r ? e.concat(r(t)) : e;
},
    me = E,
    ye = ve,
    ge = n,
    we = A,
    be = o,
    Oe = /#|\.prototype\./,
    Se = function Se(t, e) {
  var r = Ee[xe(t)];
  return r == je || r != _e && ("function" == typeof e ? be(e) : !!e);
},
    xe = Se.normalize = function (t) {
  return String(t).replace(Oe, ".").toLowerCase();
},
    Ee = Se.data = {},
    _e = Se.NATIVE = "N",
    je = Se.POLYFILL = "P",
    Te = Se,
    ke = r,
    Pe = n.f,
    Le = X,
    De = H.exports,
    Ie = Q,
    Re = function Re(t, e) {
  for (var r = ye(e), n = we.f, o = ge.f, i = 0; i < r.length; i++) {
    var a = r[i];
    me(t, a) || n(t, a, o(e, a));
  }
},
    Me = Te,
    Fe = se,
    Ce = ue,
    Ve = Object.keys || function (t) {
  return Fe(t, Ce);
},
    Ae = i,
    Ge = Ve,
    Ne = y,
    qe = a.f,
    Ue = function Ue(t) {
  return function (e) {
    for (var r, n = Ne(e), o = Ge(n), i = o.length, a = 0, s = []; i > a;) {
      r = o[a++], Ae && !qe.call(n, r) || s.push(t ? [r, n[r]] : n[r]);
    }

    return s;
  };
},
    We = {
  entries: Ue(!0),
  values: Ue(!1)
}.entries;

(function (t, e) {
  var r,
      n,
      o,
      i,
      a,
      s = t.target,
      u = t.global,
      c = t.stat;
  if (r = u ? ke : c ? ke[s] || Ie(s, {}) : (ke[s] || {}).prototype) for (n in e) {
    if (i = e[n], o = t.noTargetGet ? (a = Pe(r, n)) && a.value : r[n], !Me(u ? n : s + (c ? "." : "#") + n, t.forced) && void 0 !== o) {
      if (_typeof(i) == _typeof(o)) continue;
      Re(i, o);
    }

    (t.sham || o && o.sham) && Le(i, "sham", !0), De(r, n, i, t);
  }
})({
  target: "Object",
  stat: !0
}, {
  entries: function entries(t) {
    return We(t);
  }
}), window.crypto || (window.crypto = window.msCrypto);

var Be = function Be() {
  var t;

  try {
    t = function () {
      for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 21, e = "", r = crypto.getRandomValues(new Uint8Array(t)); t--;) {
        var n = 63 & r[t];
        e += n < 36 ? n.toString(36) : n < 62 ? (n - 26).toString(36).toUpperCase() : n < 63 ? "_" : "-";
      }

      return e;
    }(36);
  } catch (e) {
    t = Date.now() + Math.random().toString(36).slice(2);
  }

  return t;
},
    ze = Be(),
    Ke = function Ke() {
  return ze = Be();
};

function Ye() {
  return Be().slice(0, 5);
}

function Xe(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function He(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}

function Je(t, e, r) {
  return e && He(t.prototype, e), r && He(t, r), t;
}

function $e(t) {
  return ($e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  })(t);
}

var Qe = {
  exports: {}
};
!function (t) {
  var e = function (t) {
    var e,
        r = Object.prototype,
        n = r.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        s = o.toStringTag || "@@toStringTag";

    function u(t, e, r) {
      return Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }

    try {
      u({}, "");
    } catch (t) {
      u = function u(t, e, r) {
        return t[e] = r;
      };
    }

    function c(t, e, r, n) {
      var o = e && e.prototype instanceof m ? e : m,
          i = Object.create(o.prototype),
          a = new k(n || []);
      return i._invoke = function (t, e, r) {
        var n = l;
        return function (o, i) {
          if (n === p) throw new Error("Generator is already running");

          if (n === d) {
            if ("throw" === o) throw i;
            return L();
          }

          for (r.method = o, r.arg = i;;) {
            var a = r.delegate;

            if (a) {
              var s = _(a, r);

              if (s) {
                if (s === v) continue;
                return s;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === l) throw n = d, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = p;
            var u = f(t, e, r);

            if ("normal" === u.type) {
              if (n = r.done ? d : h, u.arg === v) continue;
              return {
                value: u.arg,
                done: r.done
              };
            }

            "throw" === u.type && (n = d, r.method = "throw", r.arg = u.arg);
          }
        };
      }(t, r, a), i;
    }

    function f(t, e, r) {
      try {
        return {
          type: "normal",
          arg: t.call(e, r)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }

    t.wrap = c;
    var l = "suspendedStart",
        h = "suspendedYield",
        p = "executing",
        d = "completed",
        v = {};

    function m() {}

    function y() {}

    function g() {}

    var w = {};

    w[i] = function () {
      return this;
    };

    var b = Object.getPrototypeOf,
        O = b && b(b(P([])));
    O && O !== r && n.call(O, i) && (w = O);
    var S = g.prototype = m.prototype = Object.create(w);

    function x(t) {
      ["next", "throw", "return"].forEach(function (e) {
        u(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }

    function E(t, e) {
      function r(o, i, a, s) {
        var u = f(t[o], t, i);

        if ("throw" !== u.type) {
          var c = u.arg,
              l = c.value;
          return l && "object" === $e(l) && n.call(l, "__await") ? e.resolve(l.__await).then(function (t) {
            r("next", t, a, s);
          }, function (t) {
            r("throw", t, a, s);
          }) : e.resolve(l).then(function (t) {
            c.value = t, a(c);
          }, function (t) {
            return r("throw", t, a, s);
          });
        }

        s(u.arg);
      }

      var o;

      this._invoke = function (t, n) {
        function i() {
          return new e(function (e, o) {
            r(t, n, e, o);
          });
        }

        return o = o ? o.then(i, i) : i();
      };
    }

    function _(t, r) {
      var n = t.iterator[r.method];

      if (n === e) {
        if (r.delegate = null, "throw" === r.method) {
          if (t.iterator["return"] && (r.method = "return", r.arg = e, _(t, r), "throw" === r.method)) return v;
          r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var o = f(n, t.iterator, r.arg);
      if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, v;
      var i = o.arg;
      return i ? i.done ? (r[t.resultName] = i.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, v) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, v);
    }

    function j(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }

    function T(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }

    function k(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(j, this), this.reset(!0);
    }

    function P(t) {
      if (t) {
        var r = t[i];
        if (r) return r.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var o = -1,
              a = function r() {
            for (; ++o < t.length;) {
              if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
            }

            return r.value = e, r.done = !0, r;
          };

          return a.next = a;
        }
      }

      return {
        next: L
      };
    }

    function L() {
      return {
        value: e,
        done: !0
      };
    }

    return y.prototype = S.constructor = g, g.constructor = y, y.displayName = u(g, s, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === y || "GeneratorFunction" === (e.displayName || e.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, g) : (t.__proto__ = g, u(t, s, "GeneratorFunction")), t.prototype = Object.create(S), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, x(E.prototype), E.prototype[a] = function () {
      return this;
    }, t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new E(c(e, r, n, o), i);
      return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, x(S), u(S, s, "Generator"), S[i] = function () {
      return this;
    }, S.toString = function () {
      return "[object Generator]";
    }, t.keys = function (t) {
      var e = [];

      for (var r in t) {
        e.push(r);
      }

      return e.reverse(), function r() {
        for (; e.length;) {
          var n = e.pop();
          if (n in t) return r.value = n, r.done = !1, r;
        }

        return r.done = !0, r;
      };
    }, t.values = P, k.prototype = {
      constructor: k,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(T), !t) for (var r in this) {
          "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var r = this;

        function o(n, o) {
          return s.type = "throw", s.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i],
              s = a.completion;
          if ("root" === a.tryLoc) return o("end");

          if (a.tryLoc <= this.prev) {
            var u = n.call(a, "catchLoc"),
                c = n.call(a, "finallyLoc");

            if (u && c) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            } else if (u) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            } else {
              if (!c) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];

          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), v;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), T(r), v;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];

          if (r.tryLoc === t) {
            var n = r.completion;

            if ("throw" === n.type) {
              var o = n.arg;
              T(r);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, r, n) {
        return this.delegate = {
          iterator: P(t),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = e), v;
      }
    }, t;
  }(t.exports);

  try {
    regeneratorRuntime = e;
  } catch (t) {
    Function("r", "regeneratorRuntime = r")(e);
  }
}(Qe);
var Ze = Qe.exports;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function tr(t, e, r, n) {
  return new (r || (r = Promise))(function (o, i) {
    function a(t) {
      try {
        u(n.next(t));
      } catch (t) {
        i(t);
      }
    }

    function s(t) {
      try {
        u(n["throw"](t));
      } catch (t) {
        i(t);
      }
    }

    function u(t) {
      var e;
      t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
        t(e);
      })).then(a, s);
    }

    u((n = n.apply(t, e || [])).next());
  });
}

var er = {
  development: "xxx",
  production: "xxx"
},
    rr = er.production,
    nr = er.development,
    or = "1.5.0",
    ir = function () {
  function t() {
    Xe(this, t);
    var e = navigator.userAgent;
    this.ua = e, this.os = this.detectOS(this.ua), this.os_version = this.detectOSVersion(this.ua, this.os), this.browser = this.detectBrowser(this.ua), this.browser_version = this.detectBrowserVersion(this.ua, this.browser);
  }

  return Je(t, [{
    key: "detectOS",
    value: function value(t) {
      switch (!0) {
        case /Android/.test(t):
          return "Android";

        case /iPhone|iPad|iPod/.test(t):
          return "iOS";

        case /Windows/.test(t):
          return "Windows";

        case /Mac OS X/.test(t):
          return "Mac";

        case /CrOS/.test(t):
          return "Chrome OS";

        case /Firefox/.test(t):
          return "Firefox OS";
      }

      return "";
    }
  }, {
    key: "detectOSVersion",
    value: function value(t, e) {
      switch (e) {
        case "Android":
          return this.getVersion(t, "Android");

        case "iOS":
          return this.getVersion(t, /OS /);

        case "Windows":
          return this.getVersion(t, /Phone/.test(t) ? /Windows Phone (?:OS )?/ : /Windows NT/);

        case "Mac":
          return this.getVersion(t, /Mac OS X /);
      }

      return "0.0.0";
    }
  }, {
    key: "getVersion",
    value: function value(t, e) {
      try {
        return this.normalizeSemverString(t.split(e)[1].trim().split(/[^\w.]/)[0]);
      } catch (t) {}

      return "0.0.0";
    }
  }, {
    key: "normalizeSemverString",
    value: function value(t) {
      var e = t.split(/[._]/);
      return (parseInt(e[0], 10) || 0) + "." + (parseInt(e[1], 10) || 0) + "." + (parseInt(e[2], 10) || 0);
    }
  }, {
    key: "detectBrowser",
    value: function value(t) {
      var e = /Android/.test(t);

      switch (!0) {
        case /CriOS/.test(t):
          return "Chrome for iOS";

        case /Edge/.test(t):
          return "Edge";

        case e && /Silk\//.test(t):
          return "Silk";

        case /Chrome/.test(t):
          return "Chrome";

        case /Firefox/.test(t):
          return "Firefox";

        case e:
          return "AOSP";

        case /MSIE|Trident/.test(t):
          return "IE";

        case /Safari\//.test(t):
          return "Safari";

        case /AppleWebKit/.test(t):
          return "WebKit";
      }

      return "";
    }
  }, {
    key: "detectBrowserVersion",
    value: function value(t, e) {
      switch (e) {
        case "Chrome for iOS":
          return this.getVersion(t, "CriOS/");

        case "Edge":
          return this.getVersion(t, "Edge/");

        case "Chrome":
          return this.getVersion(t, "Chrome/");

        case "Firefox":
          return this.getVersion(t, "Firefox/");

        case "Silk":
          return this.getVersion(t, "Silk/");

        case "AOSP":
          return this.getVersion(t, "Version/");

        case "IE":
          return /IEMobile/.test(t) ? this.getVersion(t, "IEMobile/") : /MSIE/.test(t) ? this.getVersion(t, "MSIE ") : this.getVersion(t, "rv:");

        case "Safari":
          return this.getVersion(t, "Version/");

        case "WebKit":
          return this.getVersion(t, "WebKit/");
      }

      return "0.0.0";
    }
  }]), t;
}();

function ar(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var r = 0, n = new Array(e); r < e; r++) {
    n[r] = t[r];
  }

  return n;
}

function sr(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

    if (null != r) {
      var n,
          o,
          i = [],
          a = !0,
          s = !1;

      try {
        for (r = r.call(t); !(a = (n = r.next()).done) && (i.push(n.value), !e || i.length !== e); a = !0) {
          ;
        }
      } catch (t) {
        s = !0, o = t;
      } finally {
        try {
          a || null == r["return"] || r["return"]();
        } finally {
          if (s) throw o;
        }
      }

      return i;
    }
  }(t, e) || function (t, e) {
    if (t) {
      if ("string" == typeof t) return ar(t, e);
      var r = Object.prototype.toString.call(t).slice(8, -1);
      return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ar(t, e) : void 0;
    }
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function ur(t) {
  var e,
      r,
      n,
      o = "";

  for (e = 0, r = (t += "").length; e < r; e++) {
    o += (n = t.charCodeAt(e).toString(16)).length < 2 ? "0" + n : n;
  }

  return o;
}

function cr(t, e) {
  return (cr = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function fr(t, e) {
  return !e || "object" !== $e(e) && "function" != typeof e ? function (t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }(t) : e;
}

function lr(t) {
  return (lr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function hr() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function pr(t, e, r) {
  return (pr = hr() ? Reflect.construct : function (t, e, r) {
    var n = [null];
    n.push.apply(n, e);
    var o = new (Function.bind.apply(t, n))();
    return r && cr(o, r.prototype), o;
  }).apply(null, arguments);
}

function dr(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (dr = function dr(t) {
    if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
    var r;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, n);
    }

    function n() {
      return pr(t, arguments, lr(this).constructor);
    }

    return n.prototype = Object.create(t.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), cr(n, t);
  })(t);
}

function vr(t) {
  var e = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }();

  return function () {
    var r,
        n = lr(t);

    if (e) {
      var o = lr(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);

    return fr(this, r);
  };
}

var mr = function (t) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && cr(t, e);
  }(r, dr(Error));
  var e = vr(r);

  function r(t) {
    var n;
    return Xe(this, r), (n = e.call(this, t)).name = "LinkMonitorError", n.message = "[LinkMonitorError]: " + t || "[LinkMonitorError]: Error", n;
  }

  return r;
}(),
    yr = function () {
  function t(e, r) {
    var n = this;
    if (Xe(this, t), this.act = "", this.url = "", this.defaultOptions = {}, this.queue = [], this.queueIsRIFScheduled = !1, this.upload = function (t) {
      if (n.queueIsRIFScheduled = !1, t || (t = {
        didTimeout: !0,
        timeRemaining: function timeRemaining() {
          return Number.MAX_VALUE;
        }
      }), (null == t ? void 0 : t.timeRemaining()) > 0 || n.queue.length > 0) {
        var e = n.queue.shift();
        e && (e.reportUrl, e.reportData);
      }

      n.queue.length > 0 && n.upload();
    }, !e) throw new mr("Core类初始化需要act字段");
    if (!r) throw new mr("Core类初始化需要url字段");
    this.act = e, this.url = r, this.getDefaultOptions();
  }

  return Je(t, [{
    key: "getDefaultOptions",
    value: function value() {
      var t,
          e = this.act,
          r = or,
          n = {
        bs_ua: (t = new ir()).ua,
        bs_os: t.os,
        bs_os_version: t.os_version,
        bs_browser: t.browser,
        bs_browser_version: t.browser_version
      },
          o = {
        bs_screen_height: window.screen.height,
        bs_screen_width: window.screen.width,
        bs_color_depth: window.screen.colorDepth.toString()
      },
          i = window.navigator.javaEnabled().toString(),
          a = new Date().getTimezoneOffset().toString(),
          s = window.navigator.language,
          u = function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "2021年12月8日";

        try {
          var e = document.createElement("canvas"),
              r = e.getContext("2d"),
              n = t;
          if (!r) return Date.now() + Math.random().toString(36).slice(2);
          r.textBaseline = "top", r.font = "14px 'Arial'", r.textBaseline = "tencent", r.fillStyle = "#f60", r.fillRect(125, 1, 62, 20), r.fillStyle = "#069", r.fillText(n, 2, 15), r.fillStyle = "rgba(102, 204, 0, 0.7)", r.fillText(n, 4, 17);
          var o = e.toDataURL().replace("data:image/png;base64,", "");
          return ur(window.atob(o).slice(-16, -12));
        } catch (t) {
          return Date.now() + Math.random().toString(36).slice(2);
        }
      }();

      this.defaultOptions = Object.assign(Object.assign(Object.assign({
        act: e,
        bs_lib_plugin_version: r
      }, n), o), {
        bs_java_enabled: i,
        bs_time_zone_offset: a,
        bs_language: s,
        fg: u
      });
    }
  }, {
    key: "getDefaultDynamicOptions",
    value: function value() {
      var t = Date.now(),
          e = Math.floor(t / 1e3),
          r = document.title,
          n = window.location.href,
          o = document.referrer,
          i = {
        bs_viewport_height: document.documentElement.offsetHeight || document.body.offsetHeight,
        bs_viewport_width: document.documentElement.offsetWidth || document.body.offsetWidth
      };
      return {
        pvId: ze,
        time: e,
        bs_create_time: t,
        bs_title: r,
        bs_url: n,
        bs_referrer: o,
        bs_viewport_height: i.bs_viewport_height,
        bs_viewport_width: i.bs_viewport_width
      };
    }
  }, {
    key: "send",
    value: function value(t, e) {
      var r = this.getDefaultDynamicOptions(),
          n = Object.assign(Object.assign(Object.assign(Object.assign({}, this.defaultOptions), r), {
        eventName: t
      }), e);
      this.queue.push({
        reportUrl: this.url,
        reportData: n
      }), this.queueUpload();
    }
  }, {
    key: "queueUpload",
    value: function value() {
      var t, e;
      this.queueIsRIFScheduled || (this.queueIsRIFScheduled = !0, t = this.upload, e = {
        timeout: 2e3
      }, "requestIdleCallback" in window ? window.requestIdleCallback(t, e) : setTimeout(t, 0));
    }
  }]), t;
}();

function gr(t) {
  return t < 0 ? 0 : t;
}

var wr = function wr() {
  return new Promise(function (t) {
    for (var e, r, n = (e = {
      redirectTime: -1,
      dnsTime: -1,
      ttfbTime: -1,
      appcacheTime: -1,
      unloadTime: -1,
      tcpTime: -1,
      reqTime: -1,
      analysisTime: -1,
      blankTime: -1,
      domReadyTime: -1
    }, r = window.performance.timing, e.redirectTime = gr(r.redirectEnd - r.redirectStart), e.dnsTime = gr(r.domainLookupEnd - r.domainLookupStart), e.ttfbTime = gr(r.responseStart - r.navigationStart), e.appcacheTime = gr(r.domainLookupStart - r.fetchStart), e.unloadTime = gr(r.unloadEventEnd - r.unloadEventStart), e.tcpTime = gr(r.connectEnd - r.connectStart), e.reqTime = gr(r.responseEnd - r.responseStart), e.analysisTime = gr(r.domComplete - r.domInteractive), e.blankTime = gr((r.domInteractive || r.domLoading) - r.fetchStart), e.domReadyTime = gr(r.domContentLoadedEventEnd - r.fetchStart), e), o = Object.assign(Object.assign({}, n), {
      FMP: -1,
      LCP: -1,
      FID: -1
    }), i = setTimeout(function () {
      return t(o);
    }, 5e3), a = 0, s = [new Promise(function (t) {
      if (!window.PerformanceObserver) return t({
        FMP: -1
      });

      try {
        new PerformanceObserver(function (e, r) {
          var n,
              o = e.getEntries()[0];
          r.disconnect(), t({
            FMP: null !== (n = o.renderTime) && void 0 !== n ? n : o.startTime
          });
        }).observe({
          entryTypes: ["element"]
        });
      } catch (e) {
        return console.log("Error: can not getFMP"), t({
          FMP: -1
        });
      }
    }), new Promise(function (t) {
      if (!window.PerformanceObserver) return t({
        LCP: -1
      });

      try {
        new PerformanceObserver(function (e, r) {
          var n,
              o = e.getEntries(),
              i = o[o.length - 1];
          r.disconnect(), t({
            LCP: null !== (n = i.renderTime) && void 0 !== n ? n : i.startTime
          });
        }).observe({
          entryTypes: ["largest-contentful-paint"]
        });
      } catch (e) {
        return console.log("Error: can not getLCP"), t({
          LCP: -1
        });
      }
    }), new Promise(function (t) {
      if (!window.PerformanceObserver) return t({
        FID: -1
      });

      try {
        new PerformanceObserver(function (e, r) {
          var n = e.getEntries()[0];
          n && (r.disconnect(), t({
            FID: n.processingStart - n.startTime
          }));
        }).observe({
          type: "first-input",
          buffered: !0
        });
      } catch (e) {
        return console.log("Error: can not getFID"), t({
          FID: -1
        });
      }
    })], u = 0; u < s.length; u++) {
      Promise.resolve(s[u]).then(function (e) {
        if (e instanceof Object && (o = Object.assign(Object.assign({}, o), e)), (a += 1) == s.length) return clearTimeout(i), t(o);
      })["catch"](function () {});
    }
  });
};

var br = function () {
  function t(e) {
    Xe(this, t), this.performanceFEDLOG = e;
  }

  return Je(t, [{
    key: "init",
    value: function value() {
      return tr(this, void 0, void 0, Ze.mark(function t() {
        return Ze.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return this.tempInitPromise = this.getPerformanceData(), t.abrupt("return", this.tempInitPromise);

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "setExtraData",
    value: function value(t) {
      this.extraData = t;
    }
  }, {
    key: "getPerformanceData",
    value: function value() {
      var t = this;
      return new Promise(function (e) {
        var r;
        r = function r() {
          return tr(t, void 0, void 0, Ze.mark(function t() {
            var r, n;
            return Ze.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, wr();

                  case 2:
                    return r = t.sent, n = Object.assign({}, r), this.reportData = n, t.abrupt("return", e(n));

                  case 6:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }, "complete" === document.readyState ? r() : window.addEventListener("load", r);
      });
    }
  }, {
    key: "send",
    value: function value() {
      return tr(this, void 0, void 0, Ze.mark(function t() {
        return Ze.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.reportData) {
                  t.next = 2;
                  break;
                }

                throw new mr("please set await init() first");

              case 2:
                this.extraData && (this.reportData = Object.assign(Object.assign({}, this.extraData), this.reportData)), this.performanceFEDLOG.send("performance", this.reportData), this.tempInitPromise = void 0;

              case 5:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "startRender",
    value: function value() {
      void 0 !== this.startTime && console.warn("linkMonitor: You have already used startRender, are you sure to continue using it?"), this.startTime = Date.now();
    }
  }, {
    key: "endRender",
    value: function value() {
      return tr(this, void 0, void 0, Ze.mark(function t() {
        var e, r;
        return Ze.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (!this.isGetData) {
                  t.next = 5;
                  break;
                }

                return console.warn("you have got timing data"), t.abrupt("return");

              case 5:
                this.isGetData = !0;

              case 6:
                if (void 0 !== this.startTime) {
                  t.next = 8;
                  break;
                }

                throw new mr("you must use startRender first");

              case 8:
                return this.endTime = Date.now(), e = this.endTime - this.startTime, t.next = 12, this.tempInitPromise;

              case 12:
                return r = t.sent, this.reportData = Object.assign(Object.assign({}, r), {
                  FMP: e
                }), t.next = 16, this.send();

              case 16:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }]), t;
}(),
    Or = {
  debug: !1,
  reportUrl: rr,
  performance: !1
},
    Sr = function () {
  function t(e, r) {
    Xe(this, t), this.businessDefaultOptions = {
      version: "0.0.0",
      environment: "production",
      groupId: Ye()
    }, this.act = e, this.options = Object.assign(Object.assign({}, Or), r), this.options.debug && (this.options.reportUrl = nr), this.fedLog = new yr(e, this.options.reportUrl), this.options.performance && (this.timingRecord = this.getTiming(), !0 === this.options.performance || "auto" === this.options.performance ? this.autoGetTiming() : "manual" === this.options.performance && this.manualGetTiming());
  }

  return Je(t, [{
    key: "init",
    value: function value(t) {
      this.businessDefaultOptions = Object.assign(Object.assign({}, this.businessDefaultOptions), t);
    }
  }, {
    key: "initGroupId",
    value: function value(t) {
      var e = void 0 === t ? Ye() : String(t);
      this.businessDefaultOptions = Object.assign(Object.assign({}, this.businessDefaultOptions), {
        groupId: e
      });
    }
  }, {
    key: "report",
    value: function value(t, e) {
      if (!this.options.reportUrl) throw new mr("miss report url");

      var r = function (t) {
        return Object.entries(t).reduce(function (t, e) {
          var r = sr(e, 2),
              n = r[0],
              o = r[1];
          return t[n] = o instanceof Object ? JSON.stringify(o) : o, t;
        }, {});
      }(e),
          n = Object.assign(Object.assign({}, this.businessDefaultOptions), r);

      this.fedLog.send(t, n);
    }
  }, {
    key: "getTiming",
    value: function value() {
      if (this.options.performance) {
        if (!this.options.reportUrl) throw new mr("miss report url");
        var t = new yr("webpaymentfeperformance", this.options.reportUrl);
        return new br(t);
      }
    }
  }, {
    key: "autoGetTiming",
    value: function value() {
      return tr(this, void 0, void 0, Ze.mark(function t() {
        return Ze.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.timingRecord) {
                  t.next = 2;
                  break;
                }

                return t.abrupt("return");

              case 2:
                return t.next = 4, this.timingRecord.init();

              case 4:
                return this.timingRecord.setExtraData(this.businessDefaultOptions), t.next = 7, this.timingRecord.send();

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "manualGetTiming",
    value: function value() {
      return tr(this, void 0, void 0, Ze.mark(function t() {
        return Ze.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.timingRecord) {
                  t.next = 2;
                  break;
                }

                return t.abrupt("return");

              case 2:
                return t.next = 4, this.timingRecord.init();

              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "startRecord",
    value: function value() {
      return tr(this, void 0, void 0, Ze.mark(function t() {
        return Ze.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.timingRecord && "manual" === this.options.performance) {
                  t.next = 2;
                  break;
                }

                throw new mr("did you set performance to 'manual'?");

              case 2:
                this.timingRecord.startRender();

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }, {
    key: "endRecord",
    value: function value() {
      return tr(this, void 0, void 0, Ze.mark(function t() {
        return Ze.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (this.timingRecord && "manual" === this.options.performance) {
                  t.next = 2;
                  break;
                }

                throw new mr("did you set performance to 'manual'?");

              case 2:
                this.timingRecord.setExtraData(this.businessDefaultOptions), this.timingRecord.endRender();

              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
    }
  }]), t;
}();

export { Sr as Monitor, Ye as getGroupId, Be as getPvId, ze as pvId, Ke as updatePvId };